import React from "react";
import { LastQueriesBlockProps } from "../../types/search";
import "../../styles.css";

/**
 * LastQueriesBlock - Displays a list of recent search queries
 *
 * This component shows a static list of last queries with a "Clear" button
 * that has no functionality (for default state only).
 */
const LastQueriesBlock: React.FC<LastQueriesBlockProps> = ({
  queries,
  onQueryClick,
  onClearClick,
}) => {
  const handleQueryClick = (query: string) => {
    // Optional callback for future use
    if (onQueryClick) {
      onQueryClick(query);
    }
  };

  const handleClearClick = () => {
    // Optional callback for future use
    if (onClearClick) {
      onClearClick();
    }
  };

  return (
    <div className="last-queries-block">
      <div className="block-header">
        <div className="block-title">Вы искали</div>
        <button
          type="button"
          className="clear-button"
          onClick={handleClearClick}
          aria-label="Clear search history"
        >
          Очистить
        </button>
      </div>

      {queries.length > 0 ? (
        <ul className="queries-list">
          {queries.map((item) => (
            <li key={item.id} className="query-item">
              <button
                type="button"
                className="query-button"
                onClick={() => handleQueryClick(item.query)}
                aria-label={`Search for ${item.query}`}
              >
                <img
                  className="fas fa-history query-icon"
                  src="/src/img/refresh-ccw-01.svg"
                />
                <span className="query-text">{item.query}</span>
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p className="empty-message">Нет последних запросов</p>
      )}
    </div>
  );
};

export default LastQueriesBlock;
